export const reportsRacingSingleCrewSingleSession = {
    namespaced: true,

    state: {
        table: {
            selectedSplit: 50,
            visibleColumns: []
        },
        accelerationVelocityGraph: {
            selectedPiece0: null,
            distanceIndex0: null,
            selectedPiece1: null,
            distanceIndex1: null,
            selectedPiece2: null,
            distanceIndex2: null,
            selectedPiece3: null,
            distanceIndex3: null,
            visibleSeries: [],
            visibleSeriesSet: []
        },
        accelerationCurvesGraph: {
            selectedSplit: 500
        },
        velocityCurvesGraph: {
            selectedSplit: 500
        }
    },

    getters: {
        selectedSplit(state) {
            return state.table.selectedSplit;
        },

        visibleColumns(state) {
            return state.table.visibleColumns;
        },

        selectedPiece0(state) {
            return state.accelerationVelocityGraph.selectedPiece0;
        },

        distanceIndex0(state) {
            return state.accelerationVelocityGraph.distanceIndex0;
        },

        selectedPiece1(state) {
            return state.accelerationVelocityGraph.selectedPiece1;
        },

        distanceIndex1(state) {
            return state.accelerationVelocityGraph.distanceIndex1;
        },

        selectedPiece2(state) {
            return state.accelerationVelocityGraph.selectedPiece2;
        },

        distanceIndex2(state) {
            return state.accelerationVelocityGraph.distanceIndex2;
        },

        selectedPiece3(state) {
            return state.accelerationVelocityGraph.selectedPiece3;
        },

        distanceIndex3(state) {
            return state.accelerationVelocityGraph.distanceIndex3;
        },

        visibleSeries(state) {
            return state.accelerationVelocityGraph.visibleSeries;
        },

        visibleSeriesSet(state) {
            return state.accelerationVelocityGraph.visibleSeriesSet;
        },

        accelerationCurvesSelectedSplit(state) {
            return state.accelerationCurvesGraph.selectedSplit;
        },

        velocityCurvesSelectedSplit(state) {
            return state.velocityCurvesGraph.selectedSplit;
        },

        hasAccelerationVelocityGraphData(state) {
            const { distanceIndex0, distanceIndex1, distanceIndex2 } = state.accelerationVelocityGraph;
            return distanceIndex0 !== null || distanceIndex1 !== null || distanceIndex2 !== null;
        }
    },

    mutations: {
        setSelectedSplit(state, selectedSplit) {
            state.table.selectedSplit = selectedSplit;
        },

        setVisibleColumns(state, visibleColumns) {
            state.table.visibleColumns = visibleColumns;
        },

        setSelectedPiece(state, { value, index }) {
            state.accelerationVelocityGraph[`selectedPiece${index}`] = value;
        },

        setSelectedDistance(state, { value, index }) {
            state.accelerationVelocityGraph[`distanceIndex${index}`] = value;
        },

        setAccelerationCurvesSelectedSplit(state, selectedSplit) {
            state.accelerationCurvesGraph.selectedSplit = selectedSplit;
        },

        setVelocityCurvesSelectedSplit(state, selectedSplit) {
            state.velocityCurvesGraph.selectedSplit = selectedSplit;
        },

        resetState(state) {
            state.table = {
                selectedSplit: 50,
                visibleColumns: []
            };
            state.accelerationVelocityGraph = {
                selectedPiece0: null,
                distanceIndex0: null,
                selectedPiece1: null,
                distanceIndex1: null,
                selectedPiece2: null,
                distanceIndex2: null,
                selectedPiece3: null,
                distanceIndex3: null,
                visibleSeries: [],
                visibleSeriesSet: []
            };
            state.accelerationCurvesGraph = {
                selectedSplit: 500
            };
            state.velocityCurvesGraph = {
                selectedSplit: 500
            };
        }
    }
};

export default reportsRacingSingleCrewSingleSession;
